/** Nível “Cadastro” do menu lateral (sem rota única de índice). */
export const BREADCRUMB_CADASTRO = [{ link: '', label: 'Cadastro' }];
